<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-text-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M28 7a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1h9v31a1 1 0 001 1h2a1 1 0 001-1V10h9a1 1 0 001-1V7zm16 14a1 1 0 00-1-1H25a1 1 0 00-1 1v2a1 1 0 001 1h7v17a1 1 0 001 1h2a1 1 0 001-1V24h7a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconTextAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
